import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { fmtDateTime } from "@/lib/api";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function Notifications({ tone = "light" }) {
  const [items, setItems] = useState([]);
  const nav = useNavigate();
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  const unread = items.filter((n) => !n.read).length;

  const open = async (n) => {
    if (!n.read) { await api.put(`/notifications/${n.id}/read`); load(); }
    if (n.entity_type === "cotizacion") nav(`/app/cotizaciones/${n.entity_id}`);
  };
  const readAll = async () => { await api.put("/notifications/read-all"); load(); };

  const iconColor = tone === "light" ? "text-white/80 hover:text-white" : "text-slate-500 hover:text-slate-900";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className={`relative ${iconColor} transition-colors`} data-testid="notif-bell" aria-label="Notificaciones">
          <Bell className="w-5 h-5" />
          {unread > 0 && <span className="absolute -top-1.5 -right-1.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 grid place-items-center" data-testid="notif-count">{unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-border">
          <span className="font-semibold text-sm">Notificaciones</span>
          {unread > 0 && <button onClick={readAll} className="text-xs text-interactive hover:underline" data-testid="notif-read-all">Marcar como leídas</button>}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 && <p className="text-sm text-muted-foreground p-4 text-center">Sin notificaciones.</p>}
          {items.map((n) => (
            <button key={n.id} onClick={() => open(n)} className={`w-full text-left px-4 py-3 border-b border-border hover:bg-muted transition-colors ${!n.read ? "bg-interactive/5" : ""}`} data-testid="notif-item">
              <div className="text-sm text-foreground">{n.message}</div>
              <div className="text-xs text-muted-foreground mt-1">{fmtDateTime(n.created_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
